import React, { PureComponent } from 'react';
import { FormControl, Handler } from 'react-reactive-form';
import TextareaAutosize from 'react-autosize-textarea';

interface TextAreaProps extends FormControl {
  handler: (value?: string) => Handler;
  disabled: boolean;
}

class TextArea extends PureComponent<TextAreaProps> {

  render() {
    return (
      <TextareaAutosize
        onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}
        className={`form-control${this.props.status === 'INVALID' && this.props.submitted ? ' is-invalid' : ''}`}
        {...this.props.handler()}
        disabled={this.props.disabled}      />
    );
  }
}

export const InputTextArea = (props: any) => <TextArea {...props} />;
